import { Link } from "gatsby";
import Accordion from "react-bootstrap/Accordion";
import Button from "react-bootstrap/Button";
import * as React from 'react';
export default {
  Link,
  Accordion,
  Button,
  React
};